module.exports = __webpack_public_path__ + "static/media/tem-poupup-blue-background.2e382a78.png";